import { ActivePlaylist, Playlist } from "../../../config/audio/types";

/**
 *
 * @param gain
 * @returns a value between 0 and 1
 */
export const audioClamp = (gain: number) => {
	if (gain < 0) return 0;
	if (gain > 1) return 1;
	return gain;
};

/**
 * Check if playlist needs adjustment (pure)
 */
export const activePlaylistNeedsAdjustment = (current: Playlist, next: Playlist): boolean => {
	return current.gain !== next.gain || current.isLooping !== next.isLooping;
};

/**
 * Calculate new track gains (pure)
 */
export const calculateTrackGains = (current: ActivePlaylist, next: Playlist): readonly number[] =>
	current.tracks.map((track) => track.defaultGain * next.gain);

/**
 * Diff playlists to determine actions (pure)
 */
export const diffPlaylists = (current: readonly Playlist[], next: readonly Playlist[]) => {
	const currentMap = new Map(current.map((p) => [p.name, p]));
	const nextMap = new Map(next.map((p) => [p.name, p]));

	const toStop = current.filter((playlist) => !nextMap.has(playlist.name));
	const toStart = next.filter((playlist) => !currentMap.has(playlist.name));
	const toUpdate = next.filter((playlist) => {
		const currentPlaylist = currentMap.get(playlist.name);
		return currentPlaylist && activePlaylistNeedsAdjustment(currentPlaylist, playlist);
	});

	return { toStop, toStart, toUpdate };
};
